<template>
    <div class="p-3 row justify-content-center">
        <el-card class="col-12 col-md-8 col-lg-5" header="Meu perfil">
            <el-skeleton :loading="loading" animated :rows="6">
                <template #default>
                    <el-form :disabled="saving" :model="user" label-position="top" :rules="rules" ref="formRef">
                        <el-form-item label="Seu nome" prop="name">
                            <el-input type="text" v-model="user.name"  />
                        </el-form-item>
                        <el-form-item label="Numero de telefone" prop="phone">
                            <el-input type="number" v-model="user.phone"  />
                        </el-form-item>
                        <el-form-item label="Alterar senha" prop="password">
                            <el-input type="password" v-model="user.password"  />
                        </el-form-item>

                        <el-button :loading="saving" @click="() => submit(formRef)" size="large" plain type="primary" icon="Select">
                            Salvar alterações
                        </el-button>
                    </el-form>
                </template>
            </el-skeleton>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import Api from "@/services/api";
    import { User } from "@/services/types";
    import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
    import { onBeforeMount, reactive, ref } from "vue";
    import { useRouter } from "vue-router";

    const router = useRouter()
    const loading = ref<boolean>(true)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const user = reactive<User>({
        name: '',
        phone: null,
        password: '',
        role: 'admin'
    })

    const rules = reactive<FormRules<User>>({
        name: [{required: true, message: 'Informe seu nome', min: 2}],
        phone: [{required: true, message: 'Informe seu numero'}],
        password: [{required: false}],
    })

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('auth/user')
        if (res.status != 200) {
            ElMessageBox.alert('Ocorreu um erro ao prourar seu perfil', {
                type: "error"                
            }).then(() => {
                router.push('/login')
            })
        } else {
            const data = res.data.user
            user.name = data.name
            user.phone = data.phone
            user.role = data.role
        }
        loading.value = false
    })

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true
                const data = Object.assign({}, user)
                if (user.password?.length && user.password?.length <= 0 || !user.password) {
                    delete data.password
                }
                const res = await Api.put('auth/user', data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Dados atualizados com sucesso'})
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        const erros = res.data.errors
                        console.log(formRef.value)
                        formRef.value?.fields.forEach((val) => {
                            console.log(val)
                            Object.keys(erros).forEach(field => {
                                if (val.prop == field) {
                                    val.validateState = "error"
                                    ElMessage({
                                        type: "error",
                                        message: res.data.errors[field][0]
                                    })
                                }
                            })
                        })
                    }
                } else {
                    ElMessage.error({message: "Ocorreu um erro " + res.data.message})
                }
                saving.value = false
            }
        })
    }
</script>
